import { Checkbox } from 'antd';

export type TriState = 'unchecked' | 'checked' | 'line-through';

interface TriStateCheckboxProps {
  value: TriState;
  onChange: (e: any) => void;
  disabled?: boolean;
}

const TriStateCheckbox: React.FC<TriStateCheckboxProps> = ({
  value,
  onChange,
  disabled,
}) => {
  return (
    <Checkbox
      checked={value === 'checked'}
      indeterminate={value === 'line-through'}
      onChange={onChange}
      disabled={disabled}
    />
  );
};

export default TriStateCheckbox;
